(function () {
  var STORAGE_KEY = 'elore:wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('elore:wishlist:changed'));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function addToWishlist(handle) {
    var list = getWishlist();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    saveWishlist(getWishlist().filter(function (h) { return h !== handle; }));
  }

  function toggleWishlist(handle) {
    if (isInWishlist(handle)) { removeFromWishlist(handle); return false; }
    addToWishlist(handle);
    return true;
  }

  window.EloreWishlist = {
    get: getWishlist,
    has: isInWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist
  };

  function syncButtonState(btn) {
    var handle = btn.getAttribute('data-wishlist-toggle');
    var active = isInWishlist(handle);
    btn.classList.toggle('is-active', active);
    var icon = btn.querySelector('[data-wishlist-icon]');
    if (icon) icon.textContent = active ? 'favorite' : 'favorite_border';
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function initButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      syncButtonState(btn);
      if (btn.dataset.eloreBound) return;
      btn.dataset.eloreBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(btn.getAttribute('data-wishlist-toggle'));
        syncButtonState(btn);
      });
    });
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.classList.toggle('hidden', count === 0);
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function buildCard(product) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var price = (product.price / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });

    var a = document.createElement('a');
    a.href = '/products/' + product.handle;
    a.className = 'group flex flex-col fade-in-up';
    a.innerHTML =
      '<div class="relative w-full aspect-[4/5] overflow-hidden bg-surface-container mb-4">' +
        '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy">' +
        '<button type="button" class="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-surface/90 rounded-full" data-wishlist-toggle="' + product.handle + '" aria-label="Remove from wishlist" aria-pressed="true">' +
          '<span class="material-symbols-outlined text-[18px] text-primary" data-wishlist-icon>favorite</span>' +
        '</button>' +
      '</div>' +
      '<span class="font-label-caps text-label-caps text-primary uppercase tracking-widest mb-1">' + escapeHtml(product.title) + '</span>' +
      '<span class="font-body-sm text-on-surface-variant">' + price + '</span>';

    a.querySelector('[data-wishlist-toggle]').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      removeFromWishlist(product.handle);
      renderWishlistGrid();
    });

    return a;
  }

  function renderWishlistGrid() {
    var grid = document.querySelector('[data-elore-wishlist-grid]');
    var emptyState = document.querySelector('[data-elore-wishlist-empty]');
    if (!grid) return;

    var handles = getWishlist();
    grid.innerHTML = '';

    if (handles.length === 0) {
      grid.classList.add('hidden');
      if (emptyState) emptyState.classList.remove('hidden');
      return;
    }

    grid.classList.remove('hidden');
    if (emptyState) emptyState.classList.add('hidden');

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) { if (!res.ok) throw new Error(); return res.json(); })
        .catch(function () { return null; });
    })).then(function (products) {
      products.forEach(function (product, i) {
        if (!product) { removeFromWishlist(handles[i]); return; }
        grid.appendChild(buildCard(product));
      });
      if (grid.children.length === 0) {
        grid.classList.add('hidden');
        if (emptyState) emptyState.classList.remove('hidden');
      }
    });
  }

  document.addEventListener('elore:wishlist:changed', function () {
    initButtons();
    updateWishlistCount();
    if (document.querySelector('[data-elore-wishlist-grid]')) renderWishlistGrid();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    updateWishlistCount();
    renderWishlistGrid();
  });
})();